/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-19 16:05:41
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-02-21 17:30:31
 * @FilePath: \ioc_base\src\components\common\gis\adapter\IGis-adapter.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
class IGisAdapater {
  constructor(options) {
    this.MapLayers = {}; //地图图层管理,添加的图层建议加入该对象，由该对象统一删除
    this.markerTips = {}; //地图弹出框
    this.arrChange = [];
    this.drawFeature = null; //地图绘制工具
    this.imgIndex = 16;
    this.radius = 0;
    this.imgSetTime = {};
    this.refreshTimer = {}; //动画定时器专用对象
    this.map = new iGis.GisMap();
    this.map.createMap({ ...options });
  }
  // 使用地图前的判断
  beforeHandle(name, layerId, data) {
    console.log("图层:类型-id:", name, layerId, "数据:", data);
    if (this.MapLayers[layerId]) {
      this.clearLayer(layerId);
    }
    if (this.refreshTimer[layerId]) {
      this.radius = 0;
      clearInterval(this.refreshTimer[layerId]);
      delete this.refreshTimer[layerId];
    }
    if (!data.length) {
      return false;
    } else {
      return true;
    }
  }
  /**
   * 地图添加点击事件
   * @param callBackFunc 回调函数
   */
  handleMapClickEvent(callBackFunc) {
    this.map.addCustomClickEvent(function (e) {
      if (typeof callBackFunc === "function") {
        callBackFunc(e);
      }
    });
  }
  /**
   * 地图添加右击事件
   * @param callBackFunc 回调函数
   */
  handleMapRightClickEvent(callBackFunc) {
    this.map.addCustomClickEvent(function (e) {
      if (typeof callBackFunc === "function") {
        callBackFunc(e);
      }
    });
  }
  // 图层添加事件统一处理
  handleLayerClickEvent(mapLayers, callBack, layerId) {
    let event = callBack;
    let that = this;
    if (callBack && typeof callBack === "function") {
      // 图层事件
      mapLayers.addClickEvent(function (e) {
        const _marker = e.feature.values_.property;
        callBack({ layerId: layerId, marker: _marker, info: e });
      });
    } else {
      mapLayers.addClickEvent(function (e) {
        // console.log("图层默认事件：", e, e.feature.values_.property);
      });
    }
  }
  // 图层点击事件统一处理
  handleLayerHoverEvent(mapLayers, callBack, layerId) {
    let event = callBack;
    let that = this;
    if (callBack && typeof callBack === "function") {
      // 图层事件
      mapLayers.addHoverEvent(function (e) {
        const _marker = e.feature.values_.property;
        callBack({ layerId: layerId, marker: _marker, info: e });
      });
    } else {
      mapLayers.addHoverEvent(function (e) {
        console.log("图层默认悬停事件：", e, e.feature.values_.property);
      });
    }
  }
  ClusterIconLayer(option = [], layerId = "", click, hover) {
    if (!this.beforeHandle("汇聚", layerId, option)) return;
    // 配置地图图层渲染数据格式
    let points = option.map((item, index) => {
      let pointId = item.id || "point_" + index;
      pointId = (layerId || "").trim().length
        ? (layerId || "").trim() + "-" + pointId
        : pointId;
      return {
        id: pointId,
        src: item.src || "/images/theme/newDark/map/camera.png",
        clusterSrc: item.clusterSrc || "/images/theme/newDark/map/camera.png",
        longitude: item.longitude ? item.longitude : item.coord[0],
        latitude: item.latitude ? item.latitude : item.coord[1],
        coord: item.coord,
        attr: item.attr || {},
        scale: item.scale ? item.scale : 1.2
      };
    });
    let options = {
      gisMapObj: this.map,
      isRef: true,
      // maxShowZoom: 16,
      isHover: option[0].isHover || false,
      layerOptions: {
        isAnimation: true,
        distance: 20,
        isBox: false,
        labFillColor: "red",
        labStrokeWidth: 1,
        lalFontSize: "40px",
        // minShowZoom: 5, //图层最小显示级别
        anchor: [0, 0],
        clusterAnchor: [0.5, 0.5], //汇聚图标锚点位置
        scale: 1, //控制图标大小，默认一倍
        clusterScale: 1 //控制图标大小，默认一倍
      }
    };
    let ClusterIconLayer = new iGis.layers.ClusterIconLayer(options);
    ClusterIconLayer.setData(points, 0); //设置图层数据
    iconLayer.setZIndex(1); //设置图层的显示级别
    ClusterIconLayer.refreshLayerByData(); //刷新图层数据
    console.log(ClusterIconLayer);
    // 配置该图层事件
    this.handleLayerClickEvent(ClusterIconLayer, click, layerId);
    this.handleLayerHoverEvent(ClusterIconLayer, hover, layerId);
    this.MapLayers[layerId] = ClusterIconLayer;
  }
  /**
   * 图标图层Fun
   * 打点，加载图片效果
   *
   */
  addMarket(option = [], layerId = "", click, hover) {
    if (!this.beforeHandle("图标", layerId, option)) return;
    // 配置地图图层渲染数据格式
    let points = option.map((item, index) => {
      let pointId = item.id || "point_" + index;
      pointId = (layerId || "").trim().length
        ? (layerId || "").trim() + "-" + pointId
        : pointId;
      return {
        id: pointId,
        src: item.src || "/images/theme/newDark/map/camera.png",
        longitude: item.longitude ? item.longitude : item.coord[0],
        latitude: item.latitude ? item.latitude : item.coord[1],
        oldSrc:
          item.oldSrc || item.src || "/images/theme/newDark/map/camera.png",
        coord: item.coord,
        attr: item.attr || {},
        scale: item.scale ? item.scale : 1.2,
        height: window.systemConfig.MAP_MODEL_Height || 30,
        showTips: item.showTips,
        tipsTitle: item.tipsTitle,
        upDevice: item.upDevice,
        openMusic: item.openMusic,
        openShout: item.openShout,
        tipsMap: item.tipsMap,
        anchor: item.anchor
      };
    });
    let options = {
      gisMapObj: this.map,
      isRef: true,
      isHover: option[0].isHover || false,
      layerOptions: {
        isBox: false,
        labFillColor: "#FFFFFF",
        lalFontSize: "14px",
        selSrc: option[0].sleSrc || "",
        // minShowZoom: 5, //图层最小显示级别
        anchor: option[0].anchor || [0, 0], //默认锚点坐标,,图片一般【10, 20】
        scale: 1, //控制图标大小，默认一倍
        labOffsetX: 0, //label文字偏移X轴
        labOffsetY: 0 //label文字偏移Y轴
      }
    };
    let iconLayer = new iGis.layers.IconLayer(options);
    iconLayer.setData(points, 0); //设置图层数据
    iconLayer.setZIndex(1); //设置图层的显示级别
    iconLayer.refreshLayerByData(); //刷新图层数据
    // 配置该图层事件
    // console.log("图层创建成功", layerId, iconLayer);
    this.handleLayerClickEvent(iconLayer, click, layerId);
    this.handleLayerHoverEvent(iconLayer, hover, layerId);
    this.MapLayers[layerId] = iconLayer;
  }
  /**
   * 绘制热力图层
   *@param point:{
   * longitude: center[0],
    latitude: center[1],
    radius: this.distance,
    id: idCircles,
    fillColorAlpha: 0.4,}
   *
   */
  addHeatLayer(point, layerId = "Heat_" + point.id, click) {
    if (!this.beforeHandle("热力图", layerId, point)) return;
    let data = point.map((item) => {
      return {
        coord: [+item.longitude, +item.latitude],
        ...item
      };
    });
    console.log(data);
    const circleObj = new iGis.layers.HeatLayer({
      gisMapObj: this.map,
      // isHover: true,
      // isActual: true,
      isRef: true,
      layerOptions: {
        opacity: 0.1,
        anchor: [20, 20],
        blur: 20, //模糊程度
        gradient: ["#000", "#000", "#0f0", "#000", "#f00"], //渐变
        radius: 20, //半径
        fillColor: "#161b29", //填充颜色
        // strokeColor: point.outlineColor || "#ffffff", //边线颜色
        // strokeWidth: point.outlineWidth || 5, //边线宽度
        label: "测试", //label显示内容
        labFillColor: "#fff", //字颜色
        selFillColor: point.selFillColor || "rgba(3,21,78,0.9)" //悬停后高亮颜色
        // selLabFillColor: point.selLabFillColor || "rgba(255,255,255,1)" //悬停后高亮颜色
      },
      callBackFun: (param) => {
        param.currObj.setData(data, param.seq);
      }
    });
    console.log(circleObj);
    circleObj.refreshLayerByData();
    this.handleLayerClickEvent(circleObj, click, layerId);
    this.MapLayers[layerId] = circleObj;
  }
  /**
   * 绘制圆圈图层
   *@param point:{
   * longitude: center[0],
    latitude: center[1],
    radius: this.distance,
    id: idCircles,
    fillColorAlpha: 0.4,}
   *
   */
  addCircles(point, layerId = "circle_" + point.id, click) {
    if (!this.beforeHandle("圆圈", layerId, point)) return;
    let data = point.map((item) => {
      return {
        coord: [+item.longitude, +item.latitude],
        ...item
      };
    });
    const circleObj = new iGis.layers.CircleLayer({
      gisMapObj: this.map,
      isHover: point[0].isHover || false,
      // isActual: true,
      isRef: true,
      layerOptions: {
        anchor: [20, 20],
        // isActual: true,
        // labOffsetX: 1000,
        radius: point.radius || 50, //半径
        fillColor: point.fillColor || "rgba(3,21,78,1)", //填充颜色
        strokeColor: point[0].outlineColor || "#ffffff", //边线颜色
        strokeWidth: point[0].outlineWidth || 5, //边线宽度
        label: "", //label显示内容
        // lalFontSize: "10px",
        // labOffsetX: "10",
        // labOffsetY: "10",
        labFillColor: "#fff", //字颜色
        selFillColor: point[0].selFillColor || "rgba(3,21,78,0.9)", //悬停后高亮颜色
        selLabFillColor: point[0].selLabFillColor || "rgba(255,255,255,1)" //悬停后高亮颜色
      },
      callBackFun: (param) => {
        param.currObj.setData(data, param.seq);
      }
    });
    circleObj.refreshLayerByData();
    circleObj.setZIndex(2); //设置图层的显示级别
    this.handleLayerClickEvent(circleObj, click, layerId);
    this.MapLayers[layerId] = circleObj;
  }
  /*
   * 多边形图层Fun
   * 绘制多边形等效果
   */
  addPolygonLayer({
    layerId = "lay_poly",
    fillColor = "#FFCCFF",
    strokeColor = "#fff",
    click = null,
    hover = null,
    polygonData = [],
    layerIndex = 14,
    isHover
  } = {}) {
    if (!this.beforeHandle("多边形", layerId, polygonData)) return;
    const polyOption = {
      gisMapObj: this.map,
      isHover: isHover,
      layerOptions: {
        fillColor: fillColor,
        strokeColor: strokeColor,
        labFillColor: "#1E2840",
      }
    };
    let polyLayer = new iGis.layers.PolygonLayer(polyOption);
    polyLayer.setData(polygonData, 0);
    // polyLayer.setZIndex(layerIndex);
    polyLayer.refreshLayerByData();
    click && this.handleLayerClickEvent(polyLayer, click, layerId);
    hover && this.handleLayerHoverEvent(polyLayer, hover, layerId);
    this.MapLayers[layerId] = polyLayer;
  }
  /**
   * 绘制线条
   * point:点线数据
   * options：线条样式
   * click:点击事件
   */
  addLine(layerId = "line-Layer", point, options, click) {
    if (!this.beforeHandle("OD线", layerId, point)) return;
    //  let coord=[
    //   {
    //     coord:[[],[],[]]
    //     id:"",
    //     样式：
    //   }
    // ]
    let LineLayerObj = new iGis.layers.LineLayer({
      gisMapObj: this.map,
      layerOptions: {
        arrowType: options.arrowType || 0,
        isDirect: options.isDirect || false,
        strokeWidth: options.strokeWidth || 8,
        isBorder: options.isBorder || true, //是否需要边线
        baseRadius: options.baseRadius || 10, //默认半径大小
        fillColor: options.fillColor || "rgba(3,21,78,1)", //填充颜色
        strokeColor: options.strokeColor || "rgba(62,102,181,1)", //边线颜色
        labFillColor: options.labFillColor || "red", //字颜色
        selFillColor: options.selFillColor || "rgba(3,21,78,7)", //悬停后高亮颜色
        selLabFillColor: options.selLabFillColor || "rgba(255,255,255,1)" //悬停后高亮颜色
      }
    });

    let coord = point.map((item) => {
      return {
        ...item
      };
    });
    LineLayerObj.setData(coord, 0);
    LineLayerObj.refreshLayerByData();
    this.MapLayers[layerId] = LineLayerObj;
    click && this.handleLayerClickEvent(LineLayerObj, click, layerId);
  }

  /**
   * 开始绘制图形
   * 区域绘制等场景使用
   *
   */
  drawFeatureMap(callback, layerId = "drawFeature") {
    this.drawFeature = new iGis.maptools.DrawFeature({
      gisMapObj: this.map,
      isHover: true,
      strokeColor: "#8CACCD",
      fillColor: "#8CACCD",
      strokeWidth: 5
    });
    let that = this;
    this.drawFeature.addDrawFeature("LineString", function (data) {
      setTimeout(function () {
        that.drawFeature.removeDrawFeature();
        callback(data);
      }, 10);
    });
  }
  // 结束绘制过程，和drawFeature搭配使用
  removeDrawFeature() {
    console.log(this.drawFeature);
    this.drawFeature && this.drawFeature.removeDrawFeature();
  }
  /**
   * 文字图层
   * @param rotation 字体图层旋转
   * @param labRotation 字体图层旋转角度
   */
  addTextLayer(
    layerId = "basefont-layer",
    marker = [],
    click,
    minShowZoom = 6
  ) {
    if (!this.beforeHandle("图标", layerId, marker)) return;
    const option = {
      gisMapObj: this.map,
      isHover: true,
      // callBackFun: function (param) {
      //   param.currObj.setData(marker, param.seq);
      // },
      layerOptions: {
        minShowZoom: minShowZoom,
        lalFontSize: "50px",
        labFillColor: "#fff", // "#3E76E6",
      }
    };
    let fontLayerObj = new iGis.layers.FontLayer(option);
    fontLayerObj.setZIndex(99);
    fontLayerObj.setData(marker,0)
    // fontLayerObj.refreshLayerByData();
    this.handleLayerClickEvent(fontLayerObj, click, layerId);
    this.MapLayers[layerId] = fontLayerObj;
  }
  /*
   * 地图自定义弹窗
   * 提示框等效果
   */
  addPopupMap({
    offset = [],
    position = [],
    content = '<div id="gis_popup"></div>',
    contentId = "gis_popup",
    layerId = "Tip"
  } = arg) {
    document.getElementById("igisWindowMarker").innerHTML = content;
    let MapTipsObj = new iGis.maptools.MapTips({
      gisMapObj: this.map,
      element: document.getElementById(contentId),
      offset: offset,
      positioning: "top-left"
    });
    MapTipsObj.setPosition(position);
    this.markerTips[layerId] = MapTipsObj;
  }
  /**
   * 删除提示框-IGIS,弹窗标识，是否全删
   */
  removePopup(layerId, isAll) {
    // console.log(this.markerTips);
    if (isAll) {
      // console.log("删除所有弹窗");
      Object.keys(this.markerTips).forEach((key) => {
        this.markerTips[key] && this.markerTips[key].removeMapTips();
        this.markerTips[key] = null;
        delete this.markerTips[key];
      });
    } else {
      // console.log("删除指定弹窗", layerId);
      if (this.markerTips[layerId]) {
        this.markerTips[layerId] && this.markerTips[layerId].removeMapTips();
        this.markerTips[layerId] = null;
      }
    }
  }
  /**
   * 删除指定图层-layerId
   * 适合利用map创建的任意图层，且加入MapLayers对象的id
   * @param layerId 图层ID
   */
  clearLayer(layerId) {
    if (this.MapLayers[layerId]) {
      // console.log("删除图层", layerId);
      this.MapLayers[layerId].cleanSource();
      if (this.map) {
        this.map.removeLayer(this.MapLayers[layerId]);
      }
      this.MapLayers[layerId] = null;
      delete this.MapLayers[layerId];
    } else {
      // console.log("该图层不存在", layerId);
    }
  }
  /**
   * 清除地图覆盖物
   * 包含所有图层和弹窗等
   */
  clearOverlays() {
    if (!this.MapLayers) {
      return;
    }
    // 清除地图上所有图层信息
    Object.keys(this.MapLayers).forEach((key) => {
      this.MapLayers[key].cleanSource(); //清除图层数据源
      if (this.map) {
        this.map.removeLayer(this.MapLayers[key]);
      }
      this.MapLayers[key] = null;
      delete this.MapLayers[key];
    });
    this.removePopup("", true); //去除弹窗
    this.clearAnimation(); //去除动画图层
  }
  /**
   * 设置地图中心位置
   * @param center 中心点坐标
   */
  setMapCenter(center) {
    // console.log(center);
    if (!this.map) {
      return;
    }
    this.map.setMapCenter(center);
  }

  addWmsServer(service) {
    let url = "";
    if (service === "0") {
      url = this.serverHeader + this.wxsService + this.parkUrlm;
    } else if (service === "B1") {
      url = this.serverHeader + this.wxsService + this.parkB1Urlf;
    } else {
      url = this.serverHeader + this.wxsService + this.parkB2Urlf;
    }
    // console.log(url,'------------切换楼岑')
    this.curFloor = service;
    this.$store.commit("SER_FLOOR", service);
    let wmsServer = new iGis.layers.ServiceLayer(this.map);
    wmsServer.removeWmsLayer("01wms"); //添加之前先删除上一次的图层
    wmsServer.addWmsLayer({
      serviceId: "01wms",
      url: url,
      params: {
        VERSION: "1.3.0",
        LAYERS: "gisserver"
      }
    });
    this.wmsLayers.push();
    this.mapLoading = false;
  }
  /**
   * 获取地图中心点
   * @param flag 布尔值是否为室内
   */
  getMapCenter(flag = false) {
    if (!this.map) {
      return;
    }
    this.map.getMapCenter(flag);
  }

  /**
   * 创建闪烁图层  addMarket+定时器
   * @param points 闪烁数组
   */
  addFlashMarket(points, layerId, click) {
    this.addMarket(points, layerId, click);
    if (points.length === 0) {
      return;
    }
    if (this.refreshTimer[layerId]) {
      this.radius = 0;
      clearInterval(this.refreshTimer[layerId]);
      delete this.refreshTimer[layerId];
    }
    this.addAlarmAnimation(points, layerId);
    this.refreshTimer[layerId] = setInterval(() => {
      this.radius++;
      this.addAlarmAnimation(points, layerId);
    }, 30);
  }
  addAlarmAnimation(points, layerId) {
    points.forEach((item) => {
      let rate = 50;
      let images = [];
      const alarmLevel = item.alarmLevel;
      const alarmId = item.id;
      for (let i = 22; i < 29; i++) {
        images.push(
          "images/theme/alarmImg/alarmNew/" +
            alarmLevel +
            "_000" +
            (i + 1) +
            ".png"
        );
      }
      this.radius = this.radius % rate;
      let image = images[parseInt(this.radius / (rate / images.length))];
      this.MapLayers[layerId] &&
        this.MapLayers[layerId].updateFeature(layerId + "-" + alarmId, {
          src: image
        });
    });
  }
  /**
   * 清除动画定时器
   * @param layerId 闪烁id
   */
  clearAnimation(layerId) {
    if (this.refreshTimer[layerId]) {
      clearInterval(this.refreshTimer[layerId]);
      delete this.refreshTimer[removeKey];
    } else {
      for (let key in this.refreshTimer) {
        let removeKey = key;
        this.radius = 0;
        clearInterval(this.refreshTimer[removeKey]);
        delete this.refreshTimer[removeKey];
      }
    }
  }

  /**
   * 设置地图级别
   * @param zoom 级别值
   */
  setMapZoom(zoom) {
    if (this.map) {
      this.map.setMapZoom(zoom);
    }
  }
  /*
   *@name: getMapZoom 得到地图当前层级
   *@param:{}
   *@description:
   *@return:
   */
  getMapZoom() {
    if (this.map) {
      let zoom = this.map.getMapZoom();
      return zoom;
    }
  }

  /**
   * 设置图层显示与隐藏
   * @param layerId 图层编号
   * @param visible 显示与隐藏
   */
  setLayerVisibleById(layerId, visible) {
    if (!this.map || !this.MapLayers[layerId]) {
      console.log("该图层不存在");
      return;
    }
    if (this.MapLayers[layerId]) {
      this.MapLayers[layerId].setVisible(visible);
    }
  }

  /**
   * 获取图层显隐状态
   * @param layerId 图层编号
   * @param visible 显示与隐藏
   */
  getLayerVisibleById(layerId) {
    if (!this.map || !this.MapLayers[layerId]) {
      console.log("该图层不存在");
      return;
    }
    if (this.MapLayers[layerId]) {
      return this.MapLayers[layerId].getVisible();
    }
  }

  /**
   * 设置图层数据
   * @param layerId 图层ID
   * @param markers 图层json数据
   */
  handleSetLayerData(markers, layerId) {
    if (!this.MapLayers[layerId]) {
      console.log("该图层不存在");
      return;
    }
    this.MapLayers[layerId].setData(markers);
    this.MapLayers[layerId].refreshLayerByData(); //属性图层数据
  }
  /**
   * 根据图层表示和元素id高亮元素
   * @param layerId 图层ID
   * @param featureId 元素id
   */
  setFeaHighlight(layerId, ids) {
    if (!this.MapLayers[layerId]) {
      console.log("该图层不存在");
      return;
    }
    this.MapLayers[layerId].setFeaHighlight(ids);
  }
  /**
   * 根据图层表示和元素id修改元素属性
   * @param layerId 图层ID
   * @param featureId 元素id
   * @param obj {img:"xxx"}
   */
  updateFeatureById({ layerId = "", featureId = "", obj = {} } = {}) {
    console.log(layerId);
    console.log(featureId);
    console.log(obj);
    if (!this.MapLayers[layerId]) {
      console.log("该图层不存在");
      return;
    }
    this.MapLayers[layerId].updateFeature(featureId, obj);
  }

  /**
   * 添加地图框选
   * @param layerId 框选的图层ID
   * @param callback
   */
  addBoxSelection({ layerId = "", callback = null } = {}) {
    if (!this.map) {
      this.map = null;
    }
    this.map.addBoxSelection({
      layerObj: this.MapLayers[layerId],
      endFunc: (e) => {
        const resultData = e;
        const _arr = resultData.map((v) => v.values_.property.options);
        console.log(_arr, "888887777");
        callback && callback(_arr);
        this.removeBoxSelection(layerId);
      }
    });
  }

  /**
   * 取消地图框选
   * @param layerId 框选的图层ID
   */
  removeBoxSelection(layerId) {
    if (!this.map) {
      this.map = null;
    }
    this.map.removeBoxSelection(this.MapLayers[layerId]);
  }
  /**
   * 刷新地图
   */
  refreshMap() {
    this.map.updateSize();
  }
  /**
   * 地图销毁
   */
  mapDestroy() {
    if (this.map) {
      this.map.destroyMap(false);
      this.map = null;
    }
  }
  // 地图销毁前
  beforeDestroy() {
    this.map && this.map.destroyMap();
    this.map = null;
    this.regionLayer = null;
    this.poiLayer = null;
    this.iconLayers = null;
    this.markerTips = null;
  }
  // 销毁地图并清空所有图层数据
  destroyed() {
    this.clearOverlays();
    this.mapDestroy();
    this.map = null;
  }
}
export default IGisAdapater;
